export const config = {
    useFake: false,
    backendAddress: 'http://localhost:5005',
}